/* eslint-disable react/jsx-pascal-case */
import React, { useRef } from "react";
import { Palette, API_BASE } from "../AppConfig";
import BSL_Dialog from "../components/BSL_Dialog";
import BSL_Select from "../components/BSL_Select";
import BSL_Button from "../components/BSL_Button";
import RecallQuotesLayout from "./RecallQuotesLayout";
import { useSelector, useDispatch } from "react-redux";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import { fetchTimeout } from "../components/Common";
import { updateRecallListFromWeb } from "../redux_store/appState";
import { StyledTabs, StyledTab } from "../components/BSL_CommonControls";
import { newDefaultJobState, NEW_JOB } from "../redux_store/jobState";
import { updateAPP, MAIN_PAGE } from "../redux_store/appState";
import debounce from "lodash/debounce";
import { useMemo } from "react";
import {
    BusinessIdEffect,
    containerModeEffect,
    useFetchJobPricesEffect,
    initialiseEffect,
    lastUserJobsEffect,
    mainPageEffect,
    searchEffect,
    sortByEffect,
    tabIndexEffect,
    uploadFileEffect,
} from "./component_effects/JobRecallPageEffects";
import { standard_cent_jobs, standard_lld_jobs } from "../redux_store/dummy_data";

// Material-ui Components
import Message from "../components/Message";
import Select from "@material-ui/core/Select";
import AppsIcon from "@material-ui/icons/Apps";
import ListIcon from "@material-ui/icons/List";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Backdrop from "@material-ui/core/Backdrop";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    page: {
        [theme.breakpoints.up("sm")]: {
            marginLeft: "170px",
            marginRight: "100px",
        },
        [theme.breakpoints.down("sm")]: {
            marginLeft: "80px",
            marginRight: "0px",
        },
        display: "flex",
        textAlign: "left",
        marginTop: "20px",
        minHeight: "600px",
        flexDirection: "column",
    },
    header: {
        fontWeight: "400",
        letterSpacing: "1px",
        paddingRight: "20px",
        verticalAlign: "text-top",
        color: theme.brand.LYSAGHT ? theme.palette.primary.light : Palette.Control.DarkGrey,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.brand.LYSAGHT ? "24pt" : "18pt",
        textTransform: theme.brand.LYSAGHT ? "uppercase" : "capitalize",
        fontWeight: theme.brand.LYSAGHT ? "800" : "inherit",
    },
    view_panel: {
        flexWrap: "wrap",
        marginLeft: "11px",
        display: "flex",
        alignItems: "center",
        font: "12pt " + theme.typography.fontFamily,
    },
    inline: {
        position: "relative",
        display: "inline-block",
    },
    search_container: {
        borderRadius: theme.brand.LYSAGHT ? "0px" : "50px",
        background: "white",
        border: "1px solid #6B8799",
    },
    search_icon: {
        color: theme.brand.LYSAGHT ? Palette.Lysaght.DarkBlue : "grey",
        width: "0.75em",
        height: "0.75em",
        marginLeft: "7px",
        verticalAlign: "-webkit-baseline-middle",
        marginTop: theme.brand.LYSAGHT ? "5px" : "inherit",
    },
    sort_text: {
        font: (theme.brand.FIELDERS ? "12pt " : "10pt ") + theme.typography.fontFamily,
        color: theme.brand.LYSAGHT ? "grey" : "inherit",
    },
    input: {
        display: "none",
    },
    backdrop: {
        zIndex: 10,
        color: "#fff",
        flexDirection: "column",
    },
}));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        font: "12pt " + theme.typography.fontFamily,
    },
}))(MenuItem);

const StyledSelect = withStyles((theme) => ({
    root: {
        color: theme.brand.FIELDERS ? "#002D62" : Palette.Lysaght.DarkBlue,
        marginLeft: "6px",
        font: (theme.brand.FIELDERS ? "12pt " : "10pt ") + theme.typography.fontFamily,
        marginTop: theme.brand.FIELDERS ? "0px" : "4px",
    },
}))(Select);

export default function JobRecallPage() {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [intialise, setIntialise] = React.useState(false);
    const [currentBusinessId, setCurrentBusinessId] = React.useState("");
    const [collection_tab_index, setcollection_tab_index] = React.useState(0);

    let defaultMode = "";

    const [fileinputKey, setFileinputKey] = React.useState(0);
    const [fileData, setFileData] = React.useState([]);
    const [loading, setLoading] = React.useState(
        window.debug && window.location.href.includes("use_cache") ? false : true
    );
    const [backDrop, setBackDrop] = React.useState(false);
    const [dialogData, setDialogData] = React.useState(false);
    const [showMessage, setShowMessage] = React.useState(false);
    const [readComplete, setReadComplete] = React.useState(false);
    const [viewStyle, setViewStyle] = React.useState("Grid");
    const [searchFilter, setSearchFilter] = React.useState("");
    const [containerMode, setContainerMode] = React.useState("");
    const [lastSearchFilter, setLastSearchFilter] = React.useState("");

    // Collects all the jobs
    const [searchResults, setSearchResults] = React.useState(null);
    const [prevSearchResults, setPrevSearchResults] = React.useState(null);

    const [sort, setSort] = React.useState("Last Edited");
    const [sortBy, setSortBy] = React.useState("LASTEDITED");
    const [jobs_to_show, setJobsToShow] = React.useState(
        window.debug && window.location.href.includes("use_cache")
            ? window.brand === "Fielders"
                ? standard_cent_jobs
                : standard_lld_jobs
            : []
    );

    const user = useSelector((state) => state.app.user);
    const config = useSelector((state) => state.config);
    const main_page = useSelector((state) => state.app.MAIN_PAGE);
    const businessList = useSelector((state) => state?.app?.DistributorList);
    const user_last_jobs_edited = useSelector((state) => state.app.user_last_jobs_edited);

    const [activeHit, setActiveHit] = React.useState(0);
    const [archivedHit, setArchivedHit] = React.useState(0);
    const [deletedHit, setDeletedHit] = React.useState(0);
    const [testHit, setTestHit] = React.useState(0);

    if (user?.Role >= 99) {
        if (window.debug) defaultMode = "Dev";
        else if (window.test) defaultMode = "Test";
    }

    const inputRef = React.useRef(null);

    // Define a memoized function for searching
    const doSearch = useMemo(
        () =>
            ({
                terms, // search terms
                currentBusinessId,
                collection_tab_index,
                containerMode,
                jobs_to_show,
                sortBy,
                NumRecallItems = 50,
            }) => {
                // Set previous search results
                setPrevSearchResults(jobs_to_show);
                // Set last search filter to the current search terms
                setLastSearchFilter(terms);
                // Get the business code
                let business_code =
                    currentBusinessId !== (null || undefined || "") ? currentBusinessId : user?.BusinessDetails?.Code;

                // If no business code, return
                if (!business_code) return;

                // Set the region filter
                let regionFilter = user?.BusinessDetails?.Offer?.Regions?.[0]
                    ? user?.BusinessDetails?.Offer?.Regions?.[0]
                    : "";

                // If the user's role is greater than or equal to 90; clear the region filter
                if (user?.Role >= 90) {
                    regionFilter = "";
                }

                let status = "";
                // Set the status based on the current collection tab index
                switch (collection_tab_index) {
                    case 1:
                        status = "ARCHIVED";
                        break;
                    case 2:
                        status = "DELETED";
                        break;
                    case 3:
                        status = "TEST";
                        break;
                    default:
                        status = "";
                        break;
                }

                // Make a POST request to the API to fetch the search results
                fetchTimeout(API_BASE() + `job/` + business_code, {
                    method: "POST",
                    body: JSON.stringify({
                        Status: status,
                        Container: containerMode,
                        NumItems: NumRecallItems,
                        Filter: terms,
                        POAFilter: regionFilter,
                        SortBy: sortBy,
                    }),
                })
                    .then((response) => response.json())
                    .then((json) => {
                        let jobList = json[0]?.Jobs;

                        // Set the jobs to show to the new search results
                        setJobsToShow(jobList);
                        // Set the search results to the new search results
                        setSearchResults(jobList);
                        // Set search result counts
                        const { ACTIVE, DELETED, ARCHIVED, TEST } = json[1]?.ResultExistsIn;
                        setActiveHit(status === "" ? jobList?.length : ACTIVE);
                        setArchivedHit(status === "ARCHIVED" ? jobList?.length : ARCHIVED);
                        setDeletedHit(status === "DELETED" ? jobList?.length : DELETED);
                        setTestHit(status === "TEST" ? jobList?.length : TEST);
                        // Set loading to false after a delay
                        setTimeout(() => {
                            setLoading(false);
                        }, 1000);
                    })
                    .catch((e) => {
                        // Set loading to false after a delay
                        setTimeout(() => {
                            setLoading(false);
                        }, 1000);
                    });
            },
        // Only recompute the function when jobs_to_show changes
        [jobs_to_show]
    );

    const delayedSearch = useRef(
        debounce((searchParams) => {
            doSearch(searchParams);
        }, 250)
    ).current;

    // Add all the jobRecall effects
    BusinessIdEffect({
        currentBusinessId,
        setCurrentBusinessId,
        user,
    });

    // ("Active, Archived, Deleted")
    tabIndexEffect({
        dispatch,
        doSearch,
        setLoading,
        updateRecallListFromWeb,
        sortBy,
        main_page,
        searchFilter,
        jobs_to_show,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Adds last edited jobs by user
    lastUserJobsEffect({
        jobs_to_show,
        user_last_jobs_edited,
        sortBy,
        setJobsToShow,
        doSearch,
    });

    // Effect for sorting jobs
    sortByEffect({
        doSearch,
        sortBy,
        loading,
        main_page,
        jobs_to_show,
        searchFilter,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Effect for searching jobs
    searchEffect({
        setLoading,
        sortBy,
        searchFilter,
        delayedSearch,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Container Change effect
    containerModeEffect({
        doSearch,
        dispatch,
        API_BASE,
        updateAPP,
        setLoading,
        fetchTimeout,
        setIntialise,
        sortBy,
        main_page,
        searchFilter,
        jobs_to_show,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Init Effect
    initialiseEffect({
        API_BASE,
        dispatch,
        updateAPP,
        fetchTimeout,
        setIntialise,
        updateRecallListFromWeb,
        user,
        loading,
        intialise,
        currentBusinessId,
    });

    // Scrolling effect
    mainPageEffect({
        dispatch,
        doSearch,
        setLoading,
        updateRecallListFromWeb,
        user,
        sortBy,
        loading,
        main_page,
        searchFilter,
        jobs_to_show,
        containerMode,
        currentBusinessId,
        collection_tab_index,
    });

    // Upload File
    uploadFileEffect({
        API_BASE,
        fetchTimeout,
        updateRecallListFromWeb,
        dispatch,
        setBackDrop,
        newDefaultJobState,
        setShowMessage,
        setDialogData,
        user,
        config,
        fileData,
        readComplete,
        currentBusinessId,
    });

    const args = [API_BASE, fetchTimeout, currentBusinessId, containerMode];
    const { dashData, dashLoading, dashError } = useFetchJobPricesEffect(...args);

    const handleTabChange = (event, newValue) => {
        setcollection_tab_index(newValue);
    };

    const validateFile = (file) => {
        if (file.name.endsWith(".vqu") || file.name.endsWith(".vqd")) {
            return true;
        }
        return false;
    };

    const readmultifiles = (files) => {
        var reader = new FileReader();
        var file_data = [];
        function readFile(index) {
            if (index >= files.length) {
                setFileData(file_data);
                setReadComplete(true);
                return;
            }
            var file = files[index];
            reader.onload = function (e) {
                var bin = e.target.result;
                file_data.push({ data: bin, name: file.name });
                readFile(index + 1);
            };
            reader.readAsDataURL(file);
        }
        readFile(0);
    };

    const handleFiles = (files) => {
        setFileData([]);
        setReadComplete(false);
        let valid_files = [];
        for (let i = 0; i < files.length; i++) {
            if (validateFile(files[i])) {
                valid_files.push(files[i]);
            } else {
            }
        }
        readmultifiles(valid_files);
    };

    const uploadFile = (e) => {
        if (e?.target?.files) handleFiles(e.target.files);
    };

    let businessesSorted = [];
    businessesSorted.push({
        disabled: true,
        Key: "[BBC]",
        Display: "[BBC Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status !== "ARCHIVED" && item.Type === "BBC")
                businessesSorted.push({
                    Key: item.id,
                    Display: item.id + "-" + item.Name,
                });
        }
    businessesSorted.push({
        disabled: true,
        Key: "[Engineers]",
        Display: "[Engineers Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
                businessesSorted.push({
                    Key: item.id,
                    Display: item.id + "-" + item.Name,
                });
        }
    businessesSorted.push({
        disabled: true,
        Key: "[Customers]",
        Display: "[Customers Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
                businessesSorted.push({
                    Key: item.id,
                    Display: item.id + "-" + item.Name,
                });
        }
    businessesSorted.push({
        disabled: true,
        Key: "[Archived]",
        Display: "[Archived Licenses]",
    });
    if (businessList && businessList.length > 0)
        for (var item of businessList) {
            if (item.Status === "ARCHIVED")
                businessesSorted.push({
                    Key: item.id,
                    Display: (
                        <span style={{ color: "red" }}>
                            <em>{item.id + "-" + item.Name}</em>
                        </span>
                    ),
                });
        }
    if (user?.Role >= 99) businessesSorted.push({ Key: "ALLJOBS", Display: "ALL JOBS" });

    const sortList = ["Last Edited", "First name", "Last name", "Suburb", "JobID", "Status"];

    const handleChange = (event) => {
        setSort(event.target.value);
        switch (event.target.value) {
            case "First name":
                setSortBy("FIRSTNAME");
                break;
            case "Last name":
                setSortBy("LASTNAME");
                break;
            case "Suburb":
                setSortBy("SUBURB");
                break;
            case "JobID":
                setSortBy("JOBID");
                break;
            case "Status":
                setSortBy("STATUS");
                break;
            default:
                setSortBy("LASTEDITED");
                break;
        }
    };

    const RenderSort = (
        <FormControl variant="standard" style={{ m: 1, minWidth: "120px", marginRight: "10px" }}>
            <InputLabel className={classes.sort_text} id="demo-simple-select-standard-label">
                Sort By
            </InputLabel>
            <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={sort}
                onChange={handleChange}
                label="Sort"
            >
                {sortList.map((val) => (
                    <StyledMenuItem value={val}>{val}</StyledMenuItem>
                ))}
            </Select>
        </FormControl>
    );

    return (
        <div className={classes.root}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                }}
            >
                <div className={classes.page}>
                    <div style={{ padding: "0px 14px" }}>
                        <div style={{ marginBottom: "10px" }}>
                            <span className={classes.header}>Jobs</span>
                            <BSL_Button
                                label="NEW JOB..."
                                onClick={() => {
                                    if (!config?.id || !config?.roofsheet_types) {
                                        alert(
                                            "Configuration not fully loaded yet ... please wait a moment and try again."
                                        );
                                    } else {
                                        dispatch({
                                            type: NEW_JOB,
                                            parameter: null,
                                        });
                                        dispatch(updateAPP(MAIN_PAGE, { page: "New" }));
                                    }
                                }}
                            />
                            {window.brand === "Fielders" && (
                                <>
                                    <input
                                        ref={inputRef}
                                        key={"input_" + fileinputKey}
                                        accept=".vqu,.vqd"
                                        className={classes.input}
                                        id="contained-button-file"
                                        multiple
                                        type="file"
                                        onChange={uploadFile}
                                    />
                                    <label htmlFor="contained-button-file">
                                        {user?.Role != 90 && (
                                            <BSL_Button
                                                secondary
                                                variant="contained"
                                                component="span"
                                                label="IMPORT JOB..."
                                                style={{
                                                    marginLeft: "20px",
                                                }}
                                            />
                                        )}
                                    </label>
                                </>
                            )}
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline" }}>
                            <div style={{ width: "450px" }}>
                                {viewStyle !== "Cash" && (
                                    <StyledTabs value={collection_tab_index} onChange={handleTabChange}>
                                        <StyledTab
                                            label={
                                                "Active" +
                                                (collection_tab_index === 0
                                                    ? !loading
                                                        ? " (" + activeHit + ")"
                                                        : ""
                                                    : "") +
                                                (collection_tab_index !== 0 && activeHit == 1 ? " •" : "")
                                            }
                                        />
                                        <StyledTab
                                            label={
                                                "Archived" +
                                                (collection_tab_index === 1
                                                    ? !loading
                                                        ? " (" + archivedHit + ")"
                                                        : ""
                                                    : "") +
                                                (collection_tab_index !== 1 && archivedHit == 1 ? " •" : "")
                                            }
                                        />
                                        {user?.Role >= 99 && (
                                            <StyledTab
                                                label={
                                                    "Deleted" +
                                                    (collection_tab_index === 2
                                                        ? !loading
                                                            ? " (" + deletedHit + ")"
                                                            : ""
                                                        : "") +
                                                    (collection_tab_index !== 2 && deletedHit == 1 ? " •" : "")
                                                }
                                            />
                                        )}
                                        <StyledTab
                                            label={
                                                "Test" +
                                                (collection_tab_index === 3
                                                    ? !loading
                                                        ? " (" + testHit + ")"
                                                        : ""
                                                    : "") +
                                                (collection_tab_index !== 3 && testHit == 1 ? " •" : "")
                                            }
                                        />
                                    </StyledTabs>
                                )}
                            </div>
                            <div
                                style={{ flex: "1 1 0%", display: "flex", justifyContent: "end", alignItems: "center" }}
                            >
                                {user?.Role >= 99 && (
                                    <div style={{ display: "flex", alignItems: "baseline" }}>
                                        <span className={classes.sort_text}>Container</span>
                                        <BSL_Select
                                            style={{
                                                flex: 1,
                                                maxWidth: "200px",
                                                marginRight: "20px",
                                            }}
                                            value={containerMode ? containerMode : defaultMode}
                                            tight={true}
                                            items={["Dev", "Test", "Prod"]}
                                            onChange={(e) => {
                                                setContainerMode(e.target.value);
                                                if (window.debug) {
                                                    setCurrentBusinessId("ALLJOBS");
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                                {user?.Role >= 91 && (
                                    <div style={{ display: "flex", alignItems: "baseline" }}>
                                        <span className={classes.sort_text}>Account</span>
                                        <BSL_Select
                                            style={{
                                                flex: 1,
                                                maxWidth: "600px",
                                                marginRight: "20px",
                                            }}
                                            value={currentBusinessId ? currentBusinessId : user.BusinessDetails.Code}
                                            tight={true}
                                            items={businessesSorted}
                                            onChange={(e) => {
                                                setCurrentBusinessId(e.target.value);
                                            }}
                                        />
                                    </div>
                                )}
                                <div style={{ display: "flex", width: "350px", alignItems: "baseline" }}>
                                    <div
                                        style={{
                                            display: "flex",
                                            width: "100%",
                                            justifyContent: "space-between",
                                            alignItems: "anchor-center",
                                        }}
                                    >
                                        {viewStyle !== "Cash" && (
                                            <>
                                                {RenderSort}
                                                <div className={classes.search_container}>
                                                    <SearchIcon className={classes.search_icon} />
                                                    <TextField
                                                        id="Search"
                                                        value={searchFilter}
                                                        placeholder="Search"
                                                        type="text"
                                                        onKeyPress={(e) => {
                                                            if (e.key === "Enter") {
                                                                e.target.blur();
                                                            }
                                                        }}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        onChange={(e) => {
                                                            setSearchFilter(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <SegmentedButtonGroup
                                        value={viewStyle}
                                        items={[
                                            {
                                                Key: "Grid",
                                                Display: <AppsIcon />,
                                            },
                                            {
                                                Key: "Table",
                                                Display: <ListIcon />,
                                            },
                                            {
                                                Key: "Cash",
                                                Display: <MonetizationOnIcon />,
                                                hidden: user?.Role < 90,
                                            },
                                        ].filter((item) => !item.hidden)}
                                        onChange={(e, val) => {
                                            setViewStyle(val);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {((loading && viewStyle !== "Cash") || (dashLoading && viewStyle === "Cash")) && (
                            <LinearProgress
                                style={{
                                    marginTop: "0px",
                                    height: "4px",
                                    marginBottom: "-4px",
                                }}
                                color="primary"
                            />
                        )}
                    </div>
                    {backDrop && (
                        <Backdrop className={classes.backdrop} open={backDrop}>
                            <>
                                <CircularProgress color="inherit" />
                                <br />
                                <Typography variant="overline" gutterBottom style={{ marginTop: "20px" }}>
                                    {backDrop}
                                </Typography>
                            </>
                        </Backdrop>
                    )}
                    <RecallQuotesLayout
                        searchFilter={searchFilter}
                        businessCode={currentBusinessId}
                        setLoading={setLoading}
                        loading={loading}
                        containerMode={containerMode}
                        jobs={jobs_to_show}
                        displayMode={viewStyle}
                        noJobMessage={
                            collection_tab_index === 0
                                ? searchFilter?.length > 0
                                    ? `No jobs found searching for '${searchFilter}'`
                                    : "- No Jobs ... start a new job to begin -"
                                : collection_tab_index === 1
                                ? "- No Jobs Archived -"
                                : collection_tab_index === 2
                                ? "- No Jobs Deleted -"
                                : "- No Jobs in Test -"
                        }
                        dashData={dashData}
                        dashLoading={dashLoading}
                    />
                    {((loading && viewStyle !== "Cash") || (dashLoading && viewStyle === "Cash")) && (
                        <LinearProgress
                            style={{
                                marginTop: "0px",
                                height: "4px",
                                marginBottom: "-4px",
                            }}
                            color="primary"
                        />
                    )}
                    <Message
                        open={showMessage}
                        message={showMessage?.message}
                        type={showMessage?.type}
                        onClose={() => setShowMessage(null)}
                    />
                    <BSL_Dialog
                        title={dialogData.title}
                        open={dialogData}
                        onClose={() => setDialogData(false)}
                        button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                        button1Click={() => {
                            setDialogData(false);
                            if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                        }}
                        button2Text={dialogData?.secondaryActionText}
                        button2Click={() => {
                            setDialogData(false);
                            if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                        }}
                    >
                        {dialogData.message}
                    </BSL_Dialog>
                </div>
            </div>
        </div>
    );
}
